import { createLayoutPortalToken } from '../layoutPortals/useLayoutPortal'

const header = createLayoutPortalToken('header')
const headerSlim = createLayoutPortalToken('header-slim')
const navbar = createLayoutPortalToken('navbar')
const subHeader = createLayoutPortalToken('sub-header')
const warnings = createLayoutPortalToken('warnings')

export const workspaceSidebarLayoutSymbols = {
  header,
  headerSlim,
  navbar,
  subHeader,
  warnings,
}
